import { Box } from "@mui/material";
import EmailSentSuccessfully from "components/ForgotPassword/EmailSentSuccessfully";
import ForgotPasswordForm from "components/ForgotPassword/ForgotPasswordForm";
import { useForgotPassword } from "hooks/useForgotPassword";
import { FormProvider } from "react-hook-form";

const ForgotPasswordPage: React.FC = () => {
  const { methods, onSubmit, isSubmitting, isSuccess } = useForgotPassword();

  return (
    <Box className="h-screen bg-color_F8F8F8 flex flex-col items-center justify-center">
      <Box className="flex flex-col items-center justify-center gap-4">
        {isSuccess ? (
          <EmailSentSuccessfully />
        ) : (
          <Box className="p-16 max-w-xl border bg-white rounded-xl space-y-6 border-color_E8E8E9 border-1">
            <FormProvider {...methods}>
              <form onSubmit={onSubmit} className="space-y-6">
                <ForgotPasswordForm
                  isValid={methods.formState.isValid}
                  isSubmitting={isSubmitting}
                />
              </form>
            </FormProvider>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default ForgotPasswordPage;
